import { DOCUMENT } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common.service";

@Component({
  selector: "app-articles",
  templateUrl: "./articles.component.html",
  styleUrls: ["./articles.component.scss"],
})
export class ArticlesComponent implements OnInit {
  toggleMain: boolean[] = [];
  toggleSub: boolean[][] = [];
  mode: string = "";
  id: string = "";
  mainCategories: any = [];
  imgPath: string;
  breadCrumbList: any[] = [];
  activeArticleId: number | null = null;
  articleName: string = "";
  articleData: any;
  loadingSearch: boolean = false;
  searchList: any[] = [];
  parentId: string = "";
  searchData: string = "";

  isDropdownVisible: boolean = false;
  loadingSupportCategoryAndPageById: boolean = false;
  loadingSupportPageById: boolean = false;
  showSideBar: boolean = false;
  private searchE: ElementRef;
  breadcrumbSchema: any;
  hostName: string = "";
  @ViewChild("searchE") set contentX(contentX: ElementRef) {
    if (contentX) {
      this.searchE = contentX;
    }
  }

  constructor(
    private route: ActivatedRoute,
    public commonService: CommonService,
    private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private title: Title,
    private meta: Meta
  ) {
    this.imgPath = `${commonService._ImageUrl}support-and-blog/`;
  }

  async ngOnInit(): Promise<void> {
    this.route.params.subscribe(async (params) => {
      this.mode = params.category;
      this.id = params.id;
      this.title.setTitle(params.name.split("-").join(" "));
      this.articleName = "";
      this.getBreadcrumbSupportPage(this.mode, this.id);

      if (this.mainCategories.length === 0) {
        await this.getSupportCategoryAndPageById(this.mode, this.id);
      } else {
        this.handleCategoryToggle();
      }

      if (this.mode === "category") {
        this.activeArticleId = null;
      } else if (this.mode === "article") {
        this.getSupportPageById(+params.id);
        this.articleName = params.name.split("-").join(" ");
      } else {
        this.articleName = "";
      }
    });

    this.renderer.listen("window", "click", (e: Event) => {
      if (this.searchE) {
        if (e.target != this.searchE.nativeElement) {
          this.isDropdownVisible = false;
        }
      }
    });

    this.hostName = this.commonService.getDomainFromUrl();
  }


  toggleMainCat(index: number): void {
    this.toggleMain[index] = !this.toggleMain[index];
  }

  toggleSubCat(mainIndex: number, subIndex: number): void {
    if (!this.toggleSub[mainIndex]) {
      this.toggleSub[mainIndex] = new Array(
        this.mainCategories.sub.article.length
      ).fill(false);
    }

    this.toggleSub[mainIndex][subIndex] = !this.toggleSub[mainIndex][subIndex];
    //console.log(this.toggleSub);
  }

  async getSupportCategoryAndPageById(mode: string, id: string): Promise<void> {
    this.loadingSupportCategoryAndPageById = true;

    try {
      const res = await this.commonService
        .getSupportCategoryAndPageById(mode, id)
        .toPromise();
      if (res.success) {
        this.mainCategories = res.data;
        this.initializeToggleArrays();

        if (mode === "category") {
          let mainIndex = this.mainCategories.findIndex(
            (item) => item.id === id
          );
          let subIndex = -1;

          if (mainIndex === -1) {
            mainIndex = this.mainCategories.findIndex((cat) => {
              subIndex = cat.sub.findIndex((item) => item.id === id);
              return subIndex !== -1;
            });
          }
          if (
            mainIndex !== -1 &&
            (subIndex !== -1 ||
              (subIndex === -1 && this.mainCategories[mainIndex].id === id))
          ) {
            const mainCategory = this.mainCategories[mainIndex];
            const category =
              subIndex !== -1 ? mainCategory.sub[subIndex] : mainCategory;

            if (category.ser_description) {
              const description = category.ser_description.replace(
                /<\/?[^>]+(>|$)/g,
                ""
              );

              this.commonService.setMeta("description", description);
              this.commonService.setMeta(
                "",
                description,
                true,
                "og:description"
              );
            }
            this.commonService.setMeta(
              "",
              category.name.split("-").join(" "),
              true,
              "og:title"
            );
            this.commonService.setMeta("", this.document.URL, true, "og:url");
            this.commonService.setMeta("", "article", true, "og:type");
            this.meta.removeTag('name="keywords"');

            this.handleCategoryToggle(id);
          } else {
            //console.log(`Category with id ${id} not found`);
          }
        }
      } else {
        this.router.navigate(["/not-found"]);
      }
    } catch (err) {
      //console.error(err);
    } finally {
      this.loadingSupportCategoryAndPageById = false;
    }
  }

  getSupportPageById(id: number): void {
    this.loadingSupportPageById = true;

    this.commonService.getSupportPageById(id).subscribe({
      next: (res) => {
        if (res.success) {
          this.articleData = res.data;
          if (this.articleData.description) {
            const description = this.articleData.description.replace(
              /<\/?[^>]+(>|$)/g,
              ""
            );

            this.commonService.setMeta("description", description);
            this.commonService.setMeta("", description, true, "og:description");
          }
          this.commonService.setMeta(
            "",
            this.articleData.title.split("-").join(" "),
            true,
            "og:title"
          );
          this.commonService.setMeta("", this.document.URL, true, "og:url");
          this.commonService.setMeta("", "article", true, "og:type");
          this.meta.removeTag('name="keywords"');
          this.activateCategoryToggles(res.data.cat_id, res.data.sub_id);
          this.activeArticleId = res.data.id;
        }
        this.loadingSupportPageById = false;
      },
      error: (err: HttpErrorResponse) => {
        //console.error(err);
        this.loadingSupportPageById = false;
      },
    });
  }

  getBreadcrumbSupportPage(mode: string, id: string): void {
    this.commonService.getBreadcrumbSupportPage(mode, id).subscribe({
      next: (res) => {
        if (res.success && res.data) {
          this.breadCrumbList = res.data;
          this.generateBreadcrumbSchema();
          this.parentId = res.data[0].id;
        }
      },
      error: (err: HttpErrorResponse) => {
        //console.error(err);
      },
    });
  }

  getSupportPageByIdAndBreadCrumb(id: number, name: string): void {
    this.router.navigate([
      "/pages/support-category-page/article/",
      id,
      name.split(" ").join("-"),
    ]);
    this.activeArticleId = id;
  }

  isActiveBreadcrumb(id: number): boolean {
    return this.activeArticleId === id;
  }

  getSearchSupportPage(value: string): void {
    if (value.length > 2) {
      this.isDropdownVisible = true;
      this.loadingSearch = true;
      this.commonService.getSearchSupportPage(value, this.parentId).subscribe({
        next: (res) => {
          if (res.success) {
            this.searchList = res.data;
          } else {
            this.searchList = [];
          }
          this.loadingSearch = false;
        },
        error: (err: HttpErrorResponse) => {
          //console.error(err);
          this.loadingSearch = false;
        },
      });
    } else {
      this.isDropdownVisible = false;
    }
  }

  clearInputSearch(): void {
    this.searchData = "";
    this.isDropdownVisible = false;
  }

  handleImageError(event: Event): void {
    (event.target as HTMLImageElement).src =
      "assets/images/product/placeholder.jpg";
  }

  private handleCategoryToggle(id: string = this.id): void {
    if (this.mode === "category") {
      this.toggleMain.fill(false);
      this.toggleSub.forEach((subArray) => subArray.fill(false));

      const index = this.mainCategories.findIndex(
        (category) => category.id === id
      );
      if (index !== -1) {
        this.toggleMain[index] = true;
      }

      const [mainCategoryIndex, subCategoryIndex] =
        this.findCategoryIndices(id);

      if (mainCategoryIndex !== -1) {
        this.toggleMain[mainCategoryIndex] = true;
      }
      if (mainCategoryIndex !== -1 && subCategoryIndex !== -1) {
        this.toggleSub[mainCategoryIndex][subCategoryIndex] = true;
      }
    }
  }

  private activateCategoryToggles(catId: number, subId: number): void {
    const mainIndex = this.mainCategories.findIndex(
      (category) => category.id === catId
    );
    if (mainIndex !== -1) {
      this.toggleMain[mainIndex] = true;

      const subIndex = this.mainCategories[mainIndex].sub.findIndex(
        (sub) => sub.id === subId
      );
      if (subIndex !== -1) {
        this.toggleSub[mainIndex][subIndex] = true;
      }
    }
  }

  private initializeToggleArrays(): void {
    this.toggleMain = new Array(this.mainCategories.length).fill(false);
    this.toggleSub = this.mainCategories.map((category) =>
      new Array(category.sub.length).fill(false)
    );
  }

  private findCategoryIndices(id: string): [number, number] {
    let mainCategoryIndex = -1;
    let subCategoryIndex = -1;

    this.mainCategories.some((category, mIndex) => {
      const sIndex = category.sub.findIndex((item) => item.id === id);
      if (sIndex !== -1) {
        mainCategoryIndex = mIndex;
        subCategoryIndex = sIndex;
        return true;
      }
      return false;
    });

    return [mainCategoryIndex, subCategoryIndex];
  }
  openSideBar() {
    this.showSideBar = true;
  }
  hideSideBar() {
    this.showSideBar = false;
  }

  generateBreadcrumbSchema() {
    this.breadcrumbSchema = {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": `https://${this.hostName}/`
      }].concat(this.breadCrumbList.map((breadCrumb, index) => ({
        "@type": "ListItem",
        "position": index + 2,
        "name": breadCrumb.name,
        "item": `https://${this.hostName}/pages/support-category-page/category/${breadCrumb.id}/${breadCrumb.name.split(' ').join('-')}`
      })).concat(this.articleName ? [{
        "@type": "ListItem",
        "position": this.breadCrumbList.length + 2,
        "name": this.articleName,
        "item": `https://${this.hostName}/pages/support-category-page/article/${this.activeArticleId}/${this.articleName.split(' ').join('-')}`
      }] : []))
    };

    //console.log("schema", this.breadcrumbSchema);
  }
}
